import React from 'react';
import { Lightbulb, ArrowRight } from 'lucide-react';

/**
 * RelatedQuestionsPanel - Panel affichant les questions connexes suggérées par Perplexity
 * 
 * Permet à l'utilisateur de :
 * - Voir les questions suggérées pour approfondir le sujet
 * - Cliquer sur une question pour l'utiliser comme nouvelle requête
 * - Continuer la recherche de manière guidée
 */
const RelatedQuestionsPanel = ({ 
  questions = [], 
  onQuestionClick, 
  isLoading = false 
}) => {
  if (!questions || questions.length === 0) return null;

  return (
    <div className="mt-3 p-4 bg-gradient-to-r from-purple-50 to-pink-50 border border-purple-200 rounded-lg shadow-sm">
      <h4 className="text-sm font-semibold text-purple-700 mb-3 flex items-center gap-2">
        <Lightbulb size={16} />
        💡 Questions connexes pour approfondir
      </h4>
      
      <div className="space-y-2">
        {questions.map((question, index) => (
          <button
            key={index}
            onClick={() => onQuestionClick(question)}
            disabled={isLoading}
            className="w-full text-left p-3 bg-white hover:bg-purple-50 border border-purple-200 rounded-lg transition-all duration-200 text-sm text-gray-700 hover:text-purple-700 disabled:opacity-50 disabled:cursor-not-allowed group flex items-start gap-2"
          >
            <span className="font-medium text-purple-600 flex-shrink-0">Q{index + 1}:</span>
            <span className="flex-1">{question}</span>
            <ArrowRight 
              size={16} 
              className="text-purple-400 group-hover:text-purple-600 group-hover:translate-x-1 transition-all flex-shrink-0 mt-0.5" 
            />
          </button>
        ))}
      </div>
      
      <div className="mt-3 pt-3 border-t border-purple-200">
        <p className="text-xs text-purple-600 italic">
          💡 Cliquez sur une question pour continuer votre exploration
        </p>
      </div>
    </div>
  );
};

export default RelatedQuestionsPanel;
